import { useState, useEffect } from 'react';

export function useShowMore<T>(items: T[]) {
  const getInitialCount = () => {
    if (typeof window === 'undefined') return 6; // fallback for SSR
    const width = window.innerWidth;
    if (width < 576) return 2;
    if (width < 900) return 4;
    return 6;
  };

  const [visibleCount, setVisibleCount] = useState(getInitialCount);

  useEffect(() => {
    const handleResize = () => setVisibleCount(getInitialCount());
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const showMore = () => setVisibleCount(items.length);
  const showLess = () => setVisibleCount(getInitialCount());

  const isAllVisible = visibleCount >= items.length;
  const hasMore = items.length > getInitialCount();

  return {
    visibleItems: items.slice(0, visibleCount),
    showMore,
    showLess,
    isAllVisible,
    hasMore,
  };
}
